import composeInstallation from '../utils/composeInstallation'

const install = composeInstallation({
  name: 'workMagic',
  scriptId: 'workMagic',
  install: () => {
    /* eslint-disable */
    (function(w, d, u) {
        if (w.workmagicPixelInstalled) { return; }
        w.workmagicPixelInstalled = true;
        var s = 'script', r = d.createElement(s);
        r.src = u;
        r.async = !0;
        r.crossOrigin = 'anonymous';
        r.onload = function() {
            w.WorkmagicPixel && w.WorkmagicPixel.init({
                tenantId: "150208",
                tenantIdSign: "v1_5375240bbb93a2843ac2471aa8f815b50e3372e2",
                source: "custom-built-website"
            });
        };
        var f = d.getElementsByTagName(s)[0];
        f.parentNode.insertBefore(r, f);
    })(window, document, 'https://fe-assets.workmagic.io/pixel/latest/wm.min.js');
    /* eslint-enable */
}
})

export { install }